import styled, {keyframes} from "styled-components";

const Load = keyframes`
  0%,
  80%,
  100% {
    box-shadow: 0 1.5em 0 -1.3em;
  }
  40% {
    box-shadow: 0 1.5em 0 0;
  }
`;

export const LoadingDotBox = styled.div<{animationDelay: string}>`
  border-radius: 50%;
  width: 1.6rem;
  height: 1.5rem;
  margin-left: 25px;
  animation: ${Load} 1.7s infinite ease-in-out;
  animation-delay: ${props => props.animationDelay};
`